import { render, staticRenderFns } from "./PropertyFacilities.vue?vue&type=template&id=42fb2100&"
import script from "./PropertyFacilities.vue?vue&type=script&lang=js&"
export * from "./PropertyFacilities.vue?vue&type=script&lang=js&"
import style0 from "./PropertyFacilities.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports